module.exports = __webpack_public_path__ + "img/innovations.be7937f0.jpg";